import(/* webpackMode: "eager" */ "/vercel/path0/src/app/wishlist/page.js");
